import * as svg from "../../../assets/phone-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const PhoneIcon = iconBuilder(svg, "PhoneIcon", "0 0 14 14");
